import Modal from './modal';
export default class Modals {
    constructor() {
        this.modals = {};
        this.number = 0;
        this.defaults = {
            modal: Modal
        };
        this.initGlobalEvents();
    }
    register(modal, key = '') {
        if (!key) {
            key = 'm' + this.number;
        }
        this.modals[key] = modal;
        this.number++;
        return modal;
    }
    get(key) {
        return this.modals.hasOwnProperty(key) ? this.modals[key] : null;
    }
    open(key) {
        if (this.get(key)) {
            this.get(key).open();
        }
    }
    close(key) {
        if (this.get(key)) {
            this.get(key).close();
        }
    }
    closeAll() {
        for (let key in this.modals) {
            this.close(key);
        }
    }
    initGlobalEvents() {
        document.addEventListener('click', (e) => {
            let target = e.target;
            if (target.dataset.acModal) {
                e.preventDefault();
                this.open(target.dataset.acModal);
            }
        });
    }
}
